import { Autocomplete, TextField, Chip } from '@mui/material';
import { LANGUAGES } from '../lib/languages';

function LanguagePicker({ values, onChange, disabled = false }) {
  return (
    <Autocomplete
      multiple
      freeSolo
      fullWidth
      disabled={disabled}
      options={LANGUAGES}
      value={values}
      onChange={(event, newValue) => onChange(newValue)}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip key={key} label={option} size="small" {...tagProps} />;
        })
      }
      renderInput={(params) => <TextField {...params} label="Languages" placeholder="Add a language" />}
    />
  );
}

export default LanguagePicker;
